import { APP_FONT_FAMILIES, APP_COLORS } from "../enums";

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    primary: true;
    default: true;
  }
}

const customMuiButton: any = {
  styleOverrides: {
    root: {
      textTransform: "none",
      fontFamily: APP_FONT_FAMILIES.manrope,
      borderRadius: "10px",
    },
  },
  variants: [
    {
      props: { variant: "primary" },
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        padding: "0px 10px",
        gap: "8px",
        height: "40px",
        background: `radial-gradient(253.73% 100% at 50% 0%, ${APP_COLORS.headerDivider} 0%, ${APP_COLORS.primaryDark} 100%)`,
        color: APP_COLORS.white,
        fontFamily: APP_FONT_FAMILIES.ibmPlexMono,
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "14px",
        lineHeight: "22px",
        letterSpacing: "-0.02em",
        "&:hover": {
          background: `radial-gradient(253.73% 100% at 50% 0%, ${APP_COLORS.headerDivider} 0%, ${APP_COLORS.primaryDark} 100%)`,
        },
        "&:disabled": {
          background: APP_COLORS.greyLight6,
          color: APP_COLORS.white,
        },
      },
    },
    {
      props: { variant: "default" },
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        padding: "0px 10px",
        height: "40px",
        background: APP_COLORS.white,
        border: `1px solid ${APP_COLORS.greyLight6}`,
        boxShadow: `0px 2px 2px ${APP_COLORS.greyLight6}`,
        color: APP_COLORS.textFieldLabelBlack,
        fontFamily: APP_FONT_FAMILIES.ibmPlexMono,
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "14px",
        lineHeight: "22px",
        letterSpacing: "-0.02em",
        "&:hover": {
          background: APP_COLORS.white,
        },
      },
    },
    {
      props: { size: "small" },
      style: {
        height: "32px",
      },
    },
  ],
};

export { customMuiButton };
